import React, { useEffect, useId } from "react";
import { createPortal } from "react-dom";
import { LogOut } from "lucide-react";

const LogoutConfirmModal = ({ open, onClose, onConfirm }) => {
  const titleId = useId();

  useEffect(() => {
    if (!open) return undefined;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="prof-logout-root" role="presentation">
      <button
        type="button"
        className="prof-logout-backdrop"
        aria-label="Close dialog"
        onClick={onClose}
      />

      <div
        className="prof-logout-sheet"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(event) => event.stopPropagation()}
      >
        <span className="prof-logout-icon" aria-hidden>
          <LogOut size={20} />
        </span>
        <h2 id={titleId}>Log out?</h2>
        <p>You&apos;ll need to sign back in to access your account and wallet.</p>
        <div className="prof-logout-actions">
          <button type="button" className="prof-logout-btn prof-logout-btn-ghost" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="prof-logout-btn prof-logout-btn-danger"
            onClick={onConfirm}
          >
            Log out
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LogoutConfirmModal;
